var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-dropzone',{ref:"locationDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions}}),_vm._v(" "),_c('media-library',{attrs:{"location":_vm.location}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }